import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Blanket from '../../common/Blanket';
import FixedAD, { FIXED_AD_ID } from '../../common/FixedAD';
import Dialog from '../Dialog';
import { DownloadStateIcon } from '../DocumentDownloadDialog';
import IconCheck from '../../../img/check.gif';
import IconSpinner from '../../../img/spinner.gif';
import { useAppDataSliceSelector } from '../../../store/modules/appData';
import { PRODUCT_TYPE } from '../../../define/global';

const MobileADNDialogWrapper = styled.div`
  display: flex;
  width: 100%;
  height: fit-content;
  justify-content: center;
  align-items: center;
  flex-direction: row;

  @media (orientation: portrait) {
    flex-direction: column;
  }
`;

const MobileDialogHolder = styled.div`
  width: 322px;
  height: 250px;
  @media (orientation: portrait) {
    height: 172px;
  }
  position: relative;
  /* background: blue; */
`;

const MobileDialogBody = styled.div`
  display: flex;
  width: 322px;
  height: 202px;
  flex-flow: column;
  justify-content: center;
  align-items: center;

  @media (orientation: portrait) {
    height: 124px;
  }
`;

const MobileDownloadComment = styled.p`
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #2f3133;
  margin: 12px 0 22px 0;
`;

const MobileADBox = styled.div`
  //display: flex;
  //position: absolute;
  width: 300px;
  height: 250px;
  background: white;

  @media (orientation: portrait) {
    margin-top: 16px;
  }
  @media (orientation: landscape) {
    margin-left: 16px;
  }
`;

export default function DocumentDownloadDialogMobile({ isComplete, onClickCloseBtn, isShow }) {
  const { t } = useTranslation();
  const appData = useAppDataSliceSelector();
  return (
    <Blanket>
      <MobileADNDialogWrapper>
        <MobileDialogHolder>
          <Dialog
            title=""
            showCloseBtn={isComplete}
            showTitleSeperateLine={false}
            onClickCloseBtn={onClickCloseBtn}
            isShow={isShow}
            isBlanketTransparent>
            <MobileDialogBody>
              {isComplete ? (
                <>
                  <DownloadStateIcon src={IconCheck} />
                  <MobileDownloadComment>
                    {t('DocumentDownloadDialog.DownloadSuccess')}
                  </MobileDownloadComment>
                </>
              ) : (
                <>
                  <DownloadStateIcon src={IconSpinner} />
                  <MobileDownloadComment>
                    {t('DocumentDownloadDialog.DownloadReady')}
                  </MobileDownloadComment>
                </>
              )}
            </MobileDialogBody>
          </Dialog>
        </MobileDialogHolder>
        {appData.productType !== PRODUCT_TYPE.WITH_WHALE_SPACE && (
          <MobileADBox>
            <FixedAD id={FIXED_AD_ID.IN_DOWNLOAD_DOCUMENT} />
          </MobileADBox>
        )}
      </MobileADNDialogWrapper>
    </Blanket>
  );
}
